import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Hero from './components/mainSite/Hero';
import Dashboard from './components/adminDashboard/dashboard';
import SignIn from './components/signIn';
import Programs from './components/adminDashboard/masters/programs';
import AllPrograms from './components/mainSite/AllPrograms/Allprograms';
import "bootstrap/dist/css/bootstrap.css";
import 'bootstrap/dist/css/bootstrap.min.css';
import "bootstrap-icons/font/bootstrap-icons.css";
import Rooms from './components/mainSite/residential/rooms';
import Foods from './components/mainSite/Food/food';
import FoodsWithPrices from './components/mainSite/Food/foodwithprices'
import BookingDetails from './components/mainSite/residential/bookingDetails';
import ActivitiesPage from './components/mainSite/Activities/activities';
import Contact from './components/mainSite/contact/contact';
import Gallery from './components/mainSite/Gallary/gallery';
import VillasPage from './components/mainSite/Villas/residentials';
import DiscoverctPage from './components/mainSite/Discoversect/discover';
import ProgramDetails from './components/mainSite/Programs/programdetails';
import ScrollToTop from './components/mainSite/srollToTop'; // Import ScrollToTop
import Availability from './components/mainSite/Availability/availability';
import NotFound from './components/mainSite/notfound';

import ReactGA from "react-ga4";
import { useRef } from 'react';

// Initialize Google Analytics
ReactGA.initialize("G-TJEZC4CZ0E");
ReactGA.send({ hitType: "pageview", page: document.location.pathname });

function App() {
  const foodwithpricesRef = useRef(null)

  return (
    <Router>
      <ScrollToTop /> {/* Ensure ScrollToTop is included */}
      <FoodsWithPrices/>
      <Routes>
        <Route exact path="/" element={<Hero />} />
        <Route 
          path="/admin/*" 
          element={
            // Optionally wrap with a ProtectedRoute
            // <ProtectedRoute>
              <Dashboard />
            // </ProtectedRoute>
          } 
        />
        <Route path="/signin" element={<SignIn />} />
        <Route path="/programs" element={<Programs />} />
        <Route path="/programdetails" element={<ProgramDetails />} />
        <Route path="/rooms" element={<Rooms />} />
        <Route path="/food" element={<Foods />} />
        <Route path="/bookingdetails" element={<BookingDetails />} />
        <Route path="/activities" element={<ActivitiesPage />} />
        <Route path="/Allprograms" element={<AllPrograms />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/gallery" element={<Gallery />} />
        <Route path="/residences" element={<VillasPage />} />
        <Route path="/discover" element={<DiscoverctPage />} />
        <Route path="/availability" element={<Availability/>}/>
        <Route path="*" element={<NotFound />} />
      </Routes>
    </Router>
  );
}

export default App;
